import { VISUALIZER_REDUCER_KEY } from "../reducers/reducer";

export const getVisualizerData = (state) => {
    return state[VISUALIZER_REDUCER_KEY];
};
